export default "__VITE_ASSET__DMk0o7Mn__"